import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
var _excluded = ["file"];

/**
 * @file FileItem.ts
 * @author markJia(markjia@tencent.com)
 */
import { guid } from '@tencent/glue-util-helper';
export var UploadStatus;

(function (UploadStatus) {
  UploadStatus["DEFAULT"] = "default";
  UploadStatus["SUCCESS"] = "success";
  UploadStatus["ERROR"] = "error";
  UploadStatus["UPLOADING"] = "uploading";
  UploadStatus["REMOVED"] = "removed";
})(UploadStatus || (UploadStatus = {}));

export var FileItem = function FileItem() {
  var _this = this;

  var ops = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, FileItem);

  this.status = UploadStatus.UPLOADING;
  this.percent = 0;
  this.errMsg = '';
  this.previewUrl = '';

  this.getInfo = function () {
    var id = _this.id,
        percent = _this.percent,
        status = _this.status,
        file = _this.file,
        url = _this.url,
        errMsg = _this.errMsg,
        previewUrl = _this.previewUrl,
        xhr = _this.xhr;
    return {
      id: id,
      percent: percent,
      status: status,
      file: file,
      url: url,
      errMsg: errMsg,
      previewUrl: previewUrl,
      xhr: xhr
    };
  };

  this.updateFileItem = function (ops) {
    var file = ops.file,
        extra = _objectWithoutProperties(ops, _excluded);

    if (file && file !== _this.file) {
      _this.previewUrl && URL.revokeObjectURL(_this.previewUrl);
      _this.previewUrl = URL.createObjectURL(file);
      _this.file = file;
    }

    Object.assign(_this, extra);
  };

  this.getPercent = function () {
    return _this.percent;
  };

  this.getStatus = function () {
    return _this.status;
  };

  this.getErrMsg = function () {
    return _this.errMsg;
  };

  var id = ops.id,
      url = ops.url,
      file = ops.file;
  this.id = id || guid();
  this.url = url || '';
  this.file = file;

  if (url) {
    this.status = UploadStatus.SUCCESS;
  }

  if (file) {
    this.previewUrl = window.URL.createObjectURL(file);
  }
};